export default "__VITE_ASSET__545428c7__"